import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { useTranslate } from "ra-core";
import { useShareLinkDialog } from "../dialogs/share-link-dialog/ShareLinkDialogProvider";
import ShareIcon from '@material-ui/icons/Share';

const CreateShareLinkButton=(props) => {
    const { onClick, isDirectory, fileSystemNodePath } = props;
    const dialog = useShareLinkDialog();
    const translate = useTranslate();
    const handleOnClick = () => {
        onClick();
        dialog.open(isDirectory, fileSystemNodePath);
    }
    return (
        <ListItem button onClick={handleOnClick}>
            <ListItemIcon>
                <ShareIcon />
            </ListItemIcon>
            <ListItemText primary={translate(`cmss.resources.file-explorer.directory-actions-menu.buttons.create-share-link`)} />
        </ListItem>
    )
};
export default CreateShareLinkButton;








